<template>
  <section id="app">
    <a-layout class="layout">
      <a-layout-header id="header">
        <div id="logo" >
          <a href="/">
            <!-- <img :src="`/tenant/${tenant}/logo.svg`" width="28px"/> -->
            <div style="width: 28px;height:48px;"></div>
          </a>
        </div>
        <div id="toolbar"/>
        <header-bar style="margin-right: 24px;"/>
      </a-layout-header>
      <a-layout-content style="padding: 0;">
        <router-view/>
      </a-layout-content>
    </a-layout>
  </section>
</template>

<script>
import HeaderBar from '@/layout/HeaderBar'
import { deviceEnquire, DEVICE_TYPE } from './utils/mixin'
import { Spin } from 'ant-design-vue'

export default {
  name: 'app',
  components: { HeaderBar },
  data () {
    return {
      tenant: process.env.VUE_APP_TENANT || 'minerva'
    }
  },
  mounted () {
    this.setLoadingIndicator()
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          this.$store.commit('toggleDevice', 'desktop')
          break
        case DEVICE_TYPE.TABLET:
          this.$store.commit('toggleDevice', 'tablet')
          break
        case DEVICE_TYPE.MOBILE:
        default:
          this.$store.commit('toggleDevice', 'mobile')
          break
      }
      console.log('deviceType', deviceType)
    })
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn
    },
    userName () {
      if (this.$store.state.authentication.user) {
        return this.$store.state.authentication.user.username
      }
      return null
    }

  },
  methods: {
    handlerOnClickLogout () {
      this.$store.dispatch('authentication/logout')
    },

    setLoadingIndicator () {
      Spin.setDefaultIndicator({
        indicator: (h) => {
          return <div style="">
            <div class="loader-inner ball-scale-multiple"><div /><div /><div /></div>
          </div>
        }
      })
    }
  }
}
</script>

<style lang="less">
@import "~ant-design-vue/lib/style/index";

.loader-inner div{
  background-color: @primary-color;
}
.loader-inner {
  top: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
}
</style>

<style>
html,
body,
#app {
  /* font-family: "Avenir", Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

.layout {
  min-height: 100%;
}

.content-container table {
  border-width: 1px;
  border-spacing: 0px;
  border-style: outset;
  border-color: gray;
  border-collapse: separate;
  background-color: rgb(255, 250, 250);
}
.content-container th {
  border-width: 1px;
  padding: 3px;
  border-style: solid;
  border-color: gray;
  background-color: white;
}
.content-container td {
  border-width: 1px;
  padding: 3px;
  border-style: solid;
  border-color: gray;
  background-color: white;
}

.content-container p {
  font-size: 16px;
  font-size: 0.7vw;
  /* font-family:"Microsoft YaHei,微软雅黑"; */
  line-height: 0.1vw;
  margin-top: 10px;
}

.editr--content {
  height: 1024px;
}

.tool-box-item {
  margin: 5px;
}

/* .content-container p
{ white-space: pre; } */

</style>

<style scoped>
#logo {
  width: 80px;
  padding: 0 26px;
}

#logo img {
  position: relative;
  font-size: 1.25em;
  color: white;
}

#header {
  margin: 0;
  padding: 0;
  display: flex;
}

#toolbar {
  margin: 0 auto 0 0;

}
</style>
